import { memo } from 'react';
import Grid from '@picsart/grid/Grid';
import { Spacings } from '@picsart/cascade';
import Carousel from '@picsart/carousel/Carousel';

import { CardsWrapperProps } from './types';
import testIds from './testIds';

export const GridWrapper = memo(({ children }: CardsWrapperProps) => (
  <Grid columns="repeat(3, 1fr)" gap={Spacings.s2} placeItems="center" dataTestId={testIds.cardsWrapper}>
    {children}
  </Grid>
));

export const CarouselWrapper = memo(({ children }: CardsWrapperProps) => <Carousel hideArrows hidePagination isMultiSlide>{children}</Carousel>);
